import React from 'react';

export default function IconSmallScreen() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
        d="M18 13C18 13.5523 18.4477 14 19 14H20H27C27.5523 14 28 13.5523 28 13C28 12.4477 27.5523 12 27 12H20V5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5V12V13Z"
        fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd"
        d="M18 19C18 18.4477 18.4477 18 19 18H20H27C27.5523 18 28 18.4477 28 19C28 19.5523 27.5523 20 27 20H20V27C20 27.5523 19.5523 28 19 28C18.4477 28 18 27.5523 18 27V20V19Z"
        fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd"
        d="M14 13C14 13.5523 13.5523 14 13 14H12H5C4.44771 14 4 13.5523 4 13C4 12.4477 4.44772 12 5 12H12V5C12 4.44772 12.4477 4 13 4C13.5523 4 14 4.44772 14 5V12V13Z"
        fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd"
        d="M14 19C14 18.4477 13.5523 18 13 18H12H5C4.44771 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20H12V27C12 27.5523 12.4477 28 13 28C13.5523 28 14 27.5523 14 27V20V19Z"
        fill="currentColor" />
    </svg>
  );
}
